module.exports = __webpack_public_path__ + "static/media/ic-real-estate-exciting.4a10aa33.svg";